export const SEARCH_TYPE = {
    BUY: 'BUY',
    RENTAL: 'RENTAL'
};

export const PAGE_SIZES = [20, 50, 100];

export const REQUEST_PARAMS_NAMES = {
    PAGE: 'page',
    TYPE: 'type',
    ORDER: 'order',
    MIN_AREA: 'minArea',
    MAX_AREA: 'maxArea',
    DATE_END: 'dateEnd',
    STATUSES: 'statuses',
    PAGE_SIZE: 'pageSize',
    MIN_PRICE: 'minPrice',
    MAX_PRICE: 'maxPrice',
    PLACE_IDS: 'placeIds',
    AMENITIES: 'amenities',
    DATE_START: 'dateStart',
    AUTHOR_IDS: 'authorIds',
    TYPE_TERMS: 'typeTerms',
    COUNT_BEDS: 'countBeds',
    OBJECT_IDS: 'objectIds',
    RANGE_TYPES: 'rangeTypes',
    SOURCE_TYPES: 'sourceTypes',
    COUNT_GUESTS: 'countGuests',
    BOUND_MAX_LAT: 'boundMaxLat',
    BOUND_MIN_LAT: 'boundMinLat',
    BOUND_MAX_LNG: 'boundMaxLng',
    BOUND_MIN_LNG: 'boundMinLng',
    COUNT_BEDROOMS: 'countBedrooms',
    TYPE_APARTMENTS: 'typeApartments',
    COUNT_BATHROOMS: 'countBathrooms'
};



// WEBPACK FOOTER //
// ./src/constants/Search.js